/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AvatarPersona as AvatarPersona,
  rec_IQ as IQ,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_kx as kx,
  rec_qr as qr,
} from "../../runtime/index.jsx";
export function Componente_FQ_70_81(e) {
  let t = (0, ReactCompiler.c)(14),
    { etiqueta: n, opciones: r, valor: i, onChange: a } = e,
    [o, s] = (0, React.useState)(!1),
    c = (0, React.useRef)(null),
    l;
  if (
    (t[0] === Symbol.for(`react.memo_cache_sentinel`)
      ? ((l = () => s(!1)), (t[0] = l))
      : (l = t[0]),
    kx(o, c, l),
    r.length === 0)
  )
    return null;
  let u;
  t[1] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((u = () => s(IQ)), (t[1] = u))
    : (u = t[1]);
  let f = `Filtrar por ${n}`,
    p = `rounded p-1 transition ${i ? `text-(--accent)` : `text-(--text) opacity-50 hover:opacity-100`}`,
    m;
  t[2] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((m = (0, JSXRuntime.jsx)(qr, {
        className: `h-3 w-3`,
      })),
      (t[2] = m))
    : (m = t[2]);
  let h;
  t[3] !== f || t[4] !== p
    ? ((h = (
        <button
          type={`button`}
          onClick={u}
          aria-label={f}
          className={p}
          children={m}
        />
      )),
      (t[3] = f),
      (t[4] = p),
      (t[5] = h))
    : (h = t[5]);
  let _;
  t[6] !== o || t[7] !== a || t[8] !== r || t[9] !== i
    ? ((_ = o && (
        <AvatarPersona
          anclaRef={c}
          className={`min-w-44 rounded-xl border border-(--border) bg-(--bg) py-1 shadow-2xl`}
          children={
            <ul
              children={[
                <li
                  children={
                    <button
                      type={`button`}
                      onClick={() => {
                        (a(``), s(!1));
                      }}
                      className={`w-full px-3 py-1.5 text-left text-xs hover:bg-(--accent-bg) ${i ? `text-(--text)` : `font-medium text-(--text-h)`}`}
                      children={`Todos`}
                    />
                  }
                />,
                r.map((e) => (
                  <li
                    key={e}
                    children={
                      <button
                        type={`button`}
                        onClick={() => {
                          (a(e), s(!1));
                        }}
                        className={`w-full truncate px-3 py-1.5 text-left text-xs hover:bg-(--accent-bg) ${i === e ? `font-medium text-(--accent)` : `text-(--text-h)`}`}
                        children={e}
                      />
                    }
                  />
                )),
              ]}
            />
          }
        />
      )),
      (t[6] = o),
      (t[7] = a),
      (t[8] = r),
      (t[9] = i),
      (t[10] = _))
    : (_ = t[10]);
  let v;
  return (
    t[11] !== h || t[12] !== _
      ? ((v = (
          <span className={`relative inline-flex`} ref={c} children={[h, _]} />
        )),
        (t[11] = h),
        (t[12] = _),
        (t[13] = v))
      : (v = t[13]),
    v
  );
}
